import React from "react";
import {Button, Card, Modal, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from "react-redux";
import { updateStatusProduct,fetchProduct } from "appRedux/actions/Product";

class ModalDelete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    }
    }

    showModal = () => {
      this.setState({
        visible: true,
      });
    };

 

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El producto se ha eliminado con éxito.',
      });
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al eliminar el producto.',
      });
    }
  };
  
 
  render() {

    return (
      <div>
        <Button type="danger" onClick={this.showModal}><i className="icon icon-trash"/></Button>
        <Modal
          okText = "Borrar"
          cancelText = "Salir"
            title="Borrar"
            visible={this.state.visible}
            onOk={() => {
              //console.log(this.props.recording.id);
              this.props.updateStatusProduct(this.props.recording.id, () => { this.props.fetchProduct( ); });
              this.onNotification('success');
            }}
            onCancel={() => {
              this.props.fetchProduct( );
              this.setState({visible: false});
            }}
          >
          <p>Está seguro del eliminar el producto {this.props.recording.name}?</p>
        </Modal>
      </div>
    );
  }
}


function mapStateToProps({products}) {
  return {
    products
  }
}
export default connect(mapStateToProps, {fetchProduct, updateStatusProduct} )(ModalDelete);


// WEBPACK FOOTER //
// ./src/routes/main/Cupons/verified/ModalDelete.js